import { extendObservable, action, runInAction } from 'mobx';

class SharedFiltersStore {
    constructor() {
        extendObservable(
            this,
            {
                data: {}
            },
            {
                saveFilterMinMax: action,
                saveFilterProperty: action
            }
        );
    }

    getStatusByFilterId(filterId) {
        if (!this.data[filterId]) {
            this.data[filterId] = {};
        }

        return this.data[filterId];
    }

    saveFilterMinMaxStatus(filterId, min, max) {
        runInAction(() => {
            this.data[filterId]['min'] = min;
            this.data[filterId]['max'] = max;
        })
    }

    saveFilterPropertyStatus(filterId, propertyId, value) {
        runInAction(() => {
            this.data[filterId][propertyId] = value;
        })
    }

    reset() {
        runInAction(() => {
            Object.keys(this.data).forEach(key => this.data[key] = {});
        })
    }
}

const store = new SharedFiltersStore();

export default store;
